import React, { FC, useContext } from "react";
import { Button, Typography } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { FilterList } from "@material-ui/icons";
import { VisibilityContext } from "../../context";
import { BUTTONS } from "../../constants";

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.primary.dark,
    width: "100%",
    minHeight: "48px",

    display: "flex",
    flexDirection: "row",
    alignContent: "center",
    justifyContent: "flex-start",
  },
  filterIcon: {
    fontSize: "1.5rem",
    alignSelf: "flex-start",
    marginRight: "1.5rem",
  },
  filterText: {
    fontSize: "1rem",
    fontWeight: 600,
  },
}));

const ShowFilters: FC = () => {
  const classes = useStyles();

  const [visibilityContext, setVisibilityContext] = useContext(VisibilityContext);

  const handleVisibility = () => {
    setVisibilityContext({
      ...visibilityContext,
      menu: !visibilityContext.menu,
    });
  };

  return (
    <Button className={classes.button} size="large" variant="contained" onClick={() => handleVisibility()}>
      <FilterList className={classes.filterIcon} />
      <Typography variant="button" className={classes.filterText}>
        {BUTTONS.SHOW_FILTERS}
      </Typography>
    </Button>
  );
};

export default ShowFilters;
